import { isNil } from "lodash";
import { Component, OnInit, computed, forwardRef, input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TranslateService } from "@root/shared/service/translate.service";

type LimitValue = "nights" | "no_left_review" | "children" | "infants" | "pets" | "booked_before_day";

export const LIMIT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WidgetLimitComponent),
  multi: true,
};

@Component({
  selector: "widget-limit",
  templateUrl: "./limit.component.html",
  styleUrls: ["./limit.component.scss"],
  providers: [LIMIT_VALUE_ACCESSOR],
})
export class WidgetLimitComponent implements OnInit, ControlValueAccessor {
  showBookedBeforeDay = input(true);
  showNoLeftReview = input(true);
  // listOfLimitOption: Array<{ label: string; value: LimitValue }> =[
  //   "nights",
  //   "no_left_review",
  //   "children",
  //   "infants",
  //   "pets",
  //   "booked_before_day",
  // ].map((v) => ({
  //   label: this.t.t("automation-message-rules_html_limit_opt_" + v),
  //   value: v as LimitValue,
  // }));

  listOfLimitOption = computed(() => {
    return ["nights", "no_left_review", "children", "infants", "pets", "booked_before_day"]
      .filter((item) => {
        if (item === "no_left_review") {
          return this.showNoLeftReview();
        }
        if (item === "booked_before_day") {
          return this.showBookedBeforeDay();
        }
        return true;
      })
      .map((v) => ({
        label: this.t.t("automation-message-rules_html_limit_opt_" + v),
        value: v as LimitValue,
      }));
  });

  listOfConditionOption = [
    {
      label: this.t.t("automation-message-rules_html_limit_booked_opt_0"),
      value: 0,
    },
    { label: this.t.t("automation-message-rules_html_limit_booked_opt_s"), value: 1 },
    { label: this.t.t("automation-message-rules_html_limit_booked_opt_p", { number: 2 }), value: 2 },
    { label: this.t.t("automation-message-rules_html_limit_booked_opt_p", { number: 3 }), value: 3 },
  ];

  limitValues: Set<LimitValue> = new Set([]);
  nights = {
    start: 1,
    end: -1,
  };

  bookedBeforeDay = 0;

  _registerOnChange: (value: any) => void = (_: any) => {};

  constructor(private t: TranslateService) {}
  writeValue(value: any): void {
    if (!isNil(value?.nights_start)) {
      this.nights = {
        start: value.nights_start,
        end: value.nights_end,
      };
      this.limitValues.add("nights");
    }

    if (!isNil(value?.no_review)) {
      this.limitValues.add("no_left_review");
    }

    if (!isNil(value?.with_children)) {
      this.limitValues.add("children");
    }

    if (!isNil(value?.with_infants)) {
      this.limitValues.add("infants");
    }

    if (!isNil(value?.with_pets)) {
      this.limitValues.add("pets");
    }

    if (!isNil(value?.booked_before_day)) {
      this.bookedBeforeDay = value.booked_before_day;
      this.limitValues.add("booked_before_day");
    }
  }
  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit() {}

  onToggleLimitValue(value: LimitValue) {
    if (this.limitValues.has(value)) {
      this.limitValues.delete(value);
    } else {
      this.limitValues.add(value);
    }

    this.emitValue();
  }

  emitValue() {
    const value = {};
    if (this.limitValues.has("nights")) {
      value["nights_start"] = this.nights.start;
      value["nights_end"] = this.nights.end;
    }
    if (this.limitValues.has("no_left_review")) {
      value["no_review"] = 1;
    }
    if (this.limitValues.has("children")) {
      value["with_children"] = 1;
    }
    if (this.limitValues.has("infants")) {
      value["with_infants"] = 1;
    }
    if (this.limitValues.has("pets")) {
      value["with_pets"] = 1;
    }
    if (this.limitValues.has("booked_before_day")) {
      value["booked_before_day"] = this.bookedBeforeDay;
    }

    this._registerOnChange(value);
  }
}
